import { Switch } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { setShowMetric } from './actions';
import { ReportConfig } from './types/CohortReport';

interface Props {
    config: ReportConfig;
    setShowMetric(metric: string, checked: boolean): any;
}

const Metrics = ({ config, setShowMetric }: Props) => {
    return (
        <div className="metric-calculations">
            <div className="switch display-totals-switch">
                <Switch size="small" checked={config.showTotals} onClick={e => setShowMetric('showTotals', e)} /><div className="label">Display Total</div>
            </div>
            <div className="switch">
                <Switch size="small" checked={config.showPerPatientsPerYear} onClick={e => setShowMetric('showPerPatientsPerYear', e)} /><div className="label">Per Patient Per Year</div>
            </div>
            <div className="switch">
                <Switch size="small" checked={config.showPerPatient} onClick={e => setShowMetric('showPerPatient', e)} /><div className="label">Per Patient</div>
            </div>
            <div className="switch">
                <Switch size="small" checked={config.showPerEvent} onClick={e => setShowMetric('showPerEvent', e)} /><div className="label">Per Event</div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        config: state.hru.report.reportConfig
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
    setShowMetric: (metric: string, checked: boolean) => dispatch(setShowMetric(metric, checked))
})

export default connect(mapStateToProps, mapDispatchToProps)(Metrics)